import logo from '../assets/images/logo.png';
import logoWhite from '../assets/images/logo-white.png';

export const IMAGES = {
  LOGO: logo,
  LOGO_WHITE: logoWhite,
};